export default "__VITE_ASSET__DUJFkvUH__"